
(function($){

    function getProduct(handle) {
        return $.ajax({
            dataType: "json",
            url: '/products/' + handle + '.js',
            async: false
        }).responseJSON;
    }

    function getCartProducts() {
        const products = [];
        const cartItems = $.ajax({dataType: "json", url: '/cart.js', async: false}).responseJSON.items;

        if (cartItems.length) {
            for (const cartItem of cartItems) {
                const product = getProduct(cartItem.handle);

                if (product) {
                    products.push(product);
                }
            }
        }
        return products;
    }

    function checkAddable(productId, isReserved) {
        const products = getCartProducts();
        const reservationProducts = products.filter(function (product) {
            return product.tags.includes("reserved");
        });

        let targetCollectionProductIds = []; //予約と同時購入可能な商品のコレクション
        if(typeof reservationCollectionProductIds !== 'undefined') {
            targetCollectionProductIds = reservationCollectionProductIds;
        }

        // カートが空ならtrue
        if(!products.length) {
            return true;
        }

        //通常商品を予約商品の含まないカートに追加する場合はtrue
        if(!isReserved && !reservationProducts.length) {
            return true;
        }

        // 同一商品がカートに追加済の場合はtrue
        const includeSameProductInCart = products.some(function (product){
            return productId === product.id;
        });
        if(includeSameProductInCart) {
            return true
        }

        // 追加する商品とカート内商品が全て予約コレクションに含まれる場合はtrue
        const targetProductIds = [productId];
        products.forEach(function (product) {
            targetProductIds.push(product.id);
        });
        return targetProductIds.every(function (id){
            return targetCollectionProductIds.includes(id);
        });
    }
    window.checkAddable = checkAddable;

})(theme.jQuery);